import { findUrls } from "./urls";

/**
 * パース済みの DOM 上でベタ書き URL を <a> に置き換える。
 *
 * HTML 文字列を正規表現で直接書き換えると、置換結果が新しいタグとして解釈されうる。
 * ここではテキストノードだけを走査し、アンカーは DOM API で組み立てるため、
 * 置換によってタグが生まれることがなく XSS を持ち込まない。
 */

// これらの要素の内側にあるテキストはリンク化しない。
// A: 既にリンクなので二重に包まない。SCRIPT / STYLE: 表示テキストではない。
const SKIPPED_ANCESTORS = ["A", "SCRIPT", "STYLE"];

function hasSkippedAncestor(node, root) {
  for (let current = node.parentNode; current && current !== root; current = current.parentNode) {
    if (current.nodeType === Node.ELEMENT_NODE && SKIPPED_ANCESTORS.indexOf(current.tagName) !== -1) {
      return true;
    }
  }
  return false;
}

function replaceUrlsInTextNode(textNode, doc) {
  const text = textNode.nodeValue;
  const urls = findUrls(text);
  const replacement = doc.createDocumentFragment();
  let cursor = 0;

  urls.forEach(({ index, length, url, href }) => {
    if (index < cursor) return;
    if (index > cursor) {
      replacement.appendChild(doc.createTextNode(text.slice(cursor, index)));
    }
    const anchor = doc.createElement("a");
    // 属性の順序も Quill の Link blot（href, rel, target）に揃える。エディタが
    // 生成したリンクと表示側が生成したリンクが同じ HTML になる。
    anchor.setAttribute("href", href);
    // 別タブで開くリンク経由の window.opener 参照を断つ。
    anchor.setAttribute("rel", "noopener noreferrer");
    anchor.setAttribute("target", "_blank");
    // textContent 経由なので URL 内の < > & は自動でエスケープされる。
    anchor.textContent = url;
    replacement.appendChild(anchor);
    cursor = index + length;
  });

  if (cursor < text.length) {
    replacement.appendChild(doc.createTextNode(text.slice(cursor)));
  }

  textNode.parentNode.replaceChild(replacement, textNode);
}

/**
 * フラグメント内のベタ書き URL をリンク化する。引数を直接書き換える。
 * @param {DocumentFragment|Element} fragment
 * @returns {DocumentFragment|Element} 引数と同じ参照
 */
export function autoLinkFragment(fragment) {
  const doc = fragment.ownerDocument || document;
  const walker = doc.createTreeWalker(fragment, NodeFilter.SHOW_TEXT, null, false);
  const targets = [];

  let node;
  while ((node = walker.nextNode()) !== null) {
    if (hasSkippedAncestor(node, fragment)) continue;
    if (findUrls(node.nodeValue).length > 0) targets.push(node);
  }

  // 走査を終えてから置換する。走査中に DOM を書き換えると TreeWalker の位置が乱れる。
  targets.forEach(textNode => replaceUrlsInTextNode(textNode, doc));

  return fragment;
}
